const PropTypes = require('prop-types');
const React = require('react');
const OfferItems = require('./offer_items');

class NegotiationSubtotal extends React.Component {
  render() {
    if (this.props.offerItems.isEmpty) {
      return false;
    }

    return (
      <table>
        <tbody>
          <tr>
            <td>{I18n.t('emailOffers.totals.priceSubtotal')}</td>
            <td>{this.props.offerItems.priceSubtotal.toString()}</td>
          </tr>
          <tr>
            <td>{I18n.t('emailOffers.totals.shippingSubtotal')}</td>
            <td>{this.props.offerItems.shippingSubtotal.toString()}</td>
          </tr>
          <tr>
            <td>
              <span className="weight-bold">{I18n.t('emailOffers.totals.total')}</span>
            </td>
            <td>
              <span className="weight-bold">{this.props.offerItems.subtotal.toString()}</span>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

NegotiationSubtotal.propTypes = {
  offerItems: PropTypes.instanceOf(OfferItems),
};

module.exports = NegotiationSubtotal;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/email_offers/negotiation_subtotal.jsx